import React, { useState } from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import '../css/Lista_alunos_popup.css';

Modal.setAppElement('#root');

function ListaAlunosPopup({ isOpen, onRequestClose, studentList }) {

    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const handleStudentClick = (student) => {
        onRequestClose();
        navigate('/home-aluno', { state: { alunoSelecionado: student } });
    };

    // **Filtro para mostrar apenas os alunos que correspondem à busca**
    const filteredStudents = studentList.filter(student =>
        student.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Lista de alunos"
            className="lista-alunos-modal"
            overlayClassName="lista-alunos-overlay"
        >
            <div className="lista-alunos-content">
                <p className="cadastro-title">Lista de alunos</p>
                <div className="procurar-aluno-label-input">
                    <label htmlFor="procurarAluno">Procurar aluno:</label>
                    <input
                        id="procurarAluno"
                        type="text"
                        placeholder="Nome do aluno"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <ul className="lista-alunos">
                    {filteredStudents.length > 0 ? (
                        filteredStudents.map((student, index) => (
                            <div key={index} className="student-item">
                                <li onClick={() => handleStudentClick(student)}>
                                    {student.name}
                                </li>
                            </div>
                        ))
                    ) : (
                        <p className="nenhum-aluno">Nenhum aluno encontrado!!!</p>
                    )}
                </ul>
            </div>
        </Modal>
    );
}

export default ListaAlunosPopup;
